import { Unlink } from '@carbon/icons-react'
import { Button } from 'app/_components/Button'
import { type Suggestion, useSuggestions } from 'lib/suggestions'
import { useState } from 'react'
import { useSlate } from 'slate-react'
import { getActiveLinkUrl, insertLink, isUrl, removeLink } from '.'
import {
  LinkCombobox,
  LinkComboboxInput,
  LinkComboboxOptions,
} from './LinkCombobox'

export function LinkForm() {
  const editor = useSlate()
  const { suggestions, updateSuggestions, isLoading, resetSuggestions } =
    useSuggestions(editor.suggestLinksFetcher)
  const defaultValue = getActiveLinkUrl(editor)
  const [suggestion, setSuggestion] = useState<Suggestion | string | null>(
    defaultValue,
  )

  const [inputValue, setInputValue] = useState<string>('')

  function handleInputChange(value: string) {
    setInputValue(value)
    if (value && !isUrl(value)) {
      updateSuggestions(value)
    }
    if (!value) {
      resetSuggestions()
    }
  }

  async function handleSuggestionChange(value: Suggestion | string | null) {
    setSuggestion(value)
    if (!value) return

    const target = await editor.parseTarget(
      typeof value === 'string' ? value : value.id,
    )
    await insertLink(editor, target)
  }

  return (
    <LinkCombobox<string | Suggestion | null>
      value={suggestion}
      onChange={handleSuggestionChange}
    >
      <div className="flex">
        <LinkComboboxInput onChange={handleInputChange} />
        {defaultValue && (
          <Button
            title="Link entfernen"
            aria-label="Link entfernen"
            shape="icon"
            variant="ghost"
            onClick={() => removeLink(editor)}
          >
            <Unlink />
          </Button>
        )}
      </div>
      <LinkComboboxOptions
        suggestions={suggestions}
        isLoading={isLoading}
        query={inputValue}
      />
    </LinkCombobox>
  )
}
